// generated by tools/gen_voice.mjs. Hand edits: rewritten lines carry "mute": true (their recording no longer matches)
G.VOICE = {
 "nar_intro1": {
  "d": 4.18,
  "who": "nar",
  "t": "Two forty-seven in the morning. The release ships at dawn."
 },
 "nar_intro2": {
  "d": 3.79,
  "who": "nar",
  "t": "The build is red. It has been red for six hours."
 },
 "nar_intro3": {
  "d": 7.17,
  "who": "nar",
  "t": "Somewhere deep in the codebase, something old has woken up. And it is not happy about the refactor."
 },
 "nar_intro4": {
  "d": 4.07,
  "who": "nar",
  "t": "So one very tired developer does the only sensible thing left."
 },
 "dev_fixit": {
  "d": 1.9,
  "who": "dev",
  "t": "Fix it. Please."
 },
 "nar_intro5": {
  "mute": true,
  "d": 6.09,
  "who": "nar",
  "t": "But somebody did read it. Far away in Leaf Town, a small, extremely determined friend hopped into the screen."
 },
 "nar_w1": {
  "d": 5.25,
  "who": "nar",
  "t": "The Source Tree. Every project starts here. So does every bug."
 },
 "nar_w2": {
  "d": 7.18,
  "who": "nar",
  "t": "The Dependency Depths. Nobody knows how far down node modules goes. Nobody has come back to say."
 },
 "nar_w3": {
  "d": 5.85,
  "who": "nar",
  "t": "The Heap. Memory is allocated here. Very little of it is ever given back."
 },
 "nar_w4": {
  "d": 5.25,
  "who": "nar",
  "t": "Thread Tower. Where everything happens at once, and nothing happens in order."
 },
 "nar_w5": {
  "d": 6.45,
  "who": "nar",
  "t": "Production. It is five fifty-one. Everything is on fire. This is fine."
 },
 "null_intro": {
  "d": 7.76,
  "who": "nul",
  "t": "I am Null. I point... at nothing. And nothing is exactly what will be left of you."
 },
 "null_p2": {
  "d": 3.53,
  "who": "nul",
  "t": "Undefined... behavior..."
 },
 "null_die": {
  "d": 4.23,
  "who": "nul",
  "t": "Dereferenced... at last..."
 },
 "head_intro": {
  "d": 2.71,
  "who": "head",
  "t": "Accept MY changes!"
 },
 "theirs_intro": {
  "d": 4.52,
  "who": "theirs",
  "t": "No! Accept MINE!"
 },
 "head_alone": {
  "d": 4.33,
  "who": "head",
  "t": "Finally. My branch. My rules."
 },
 "theirs_alone": {
  "d": 5.04,
  "who": "theirs",
  "t": "At last. Mine was always the better commit."
 },
 "head_die": {
  "d": 5.22,
  "who": "head",
  "t": "Fine. We will resolve this... later."
 },
 "theirs_die": {
  "d": 7.01,
  "who": "theirs",
  "t": "Fine. We will resolve this... later."
 },
 "leak_intro": {
  "d": 6.27,
  "who": "leak",
  "t": "Allocate. Allocate. Allocate. I never let anything go."
 },
 "leak_p2": {
  "d": 4.2,
  "who": "leak",
  "t": "More. I need MORE memory!"
 },
 "leak_die": {
  "d": 5.69,
  "who": "leak",
  "t": "Freed... at last... so light..."
 },
 "loop_intro": {
  "d": 7.65,
  "who": "loop",
  "t": "While true. While true. While true. There is no exit condition, little one."
 },
 "loop_p2": {
  "d": 4.41,
  "who": "loop",
  "t": "Again. Again. AGAIN!"
 },
 "loop_die": {
  "d": 3.81,
  "who": "loop",
  "t": "Break... statement... reached."
 },
 "mono_intro": {
  "mute": true,
  "d": 13.29,
  "who": "mono",
  "t": "I am the Monolith. Four hundred thousand lines. No tests. No comments. I was here before you, little friend. I will be here long after."
 },
 "mono_p2": {
  "d": 3.86,
  "who": "mono",
  "t": "You dare refactor ME?"
 },
 "mono_p3": {
  "d": 7.63,
  "who": "mono",
  "t": "Do not touch it! It works! Nobody knows WHY it works!"
 },
 "mono_die": {
  "d": 4.37,
  "who": "mono",
  "t": "It was... load bearing..."
 },
 "nar_end1": {
  "d": 7.65,
  "who": "nar",
  "t": "Inside the oldest file in the repository, behind forty years of patches, there was no monster at all."
 },
 "nar_end2": {
  "d": 6.08,
  "who": "nar",
  "t": "Just a moth. A very small, very lost moth, looking for the light."
 },
 "nar_end4": {
  "mute": true,
  "d": 5.8,
  "who": "nar",
  "t": "At six o'clock exactly, the build turned green."
 },
 "dev_end": {
  "d": 2.11,
  "who": "dev",
  "t": "Huh. It... works?"
 },
 "nar_end5": {
  "mute": true,
  "d": 7.89,
  "who": "nar",
  "t": "The developer never did find out what happened that night. But under the TODO, someone had written: done. sleep well."
 },
 "sys_bash": {
  "d": 3.32,
  "who": "sys",
  "t": "New tool acquired. Bash."
 },
 "sys_agents": {
  "mute": true,
  "d": 3.32,
  "who": "sys",
  "t": "New tool acquired. Fireflies."
 },
 "sys_sudo": {
  "d": 3.07,
  "who": "sys",
  "t": "New tool acquired. Sudo."
 },
 "sys_opus": {
  "mute": true,
  "d": 1.54,
  "who": "sys",
  "t": "New tool acquired. Big Swipe."
 },
 "sys_pass": {
  "d": 1.96,
  "who": "sys",
  "t": "All tests passed."
 },
 "sys_fail1": {
  "d": 1.82,
  "who": "sys",
  "t": "Segmentation fault."
 },
 "sys_fail2": {
  "d": 1.28,
  "who": "sys",
  "t": "Core dumped."
 },
 "sys_fail3": {
  "d": 2.53,
  "who": "sys",
  "t": "Process exited with code one."
 }
};

